module.exports = __webpack_public_path__ + "static/media/applogo.2b7a5652.png";